import lazy from '@fawmi/vue-google-maps/src/utils/lazyValue'
import { createApp } from 'vue'
import { loadGMapApi } from '@fawmi/vue-google-maps/src/load-google-maps'
import GMapInfoWindow from '@fawmi/vue-google-maps/src/components/infoWindow.vue'
import GMapMap from '@fawmi/vue-google-maps/src/components/map.vue'
import GMapPolygon from '@fawmi/vue-google-maps/src/components/polygon'

function makeGMapApiPromiseLazy(options) {
    function onApiLoaded() {
        return window.google
    }

    if (options.load) {
        return lazy(() => new Promise((resolve, reject) => {
            try {
                window.vueGoogleMapsInit = resolve
                loadGMapApi(options.load)
            } catch (error) {
                reject(error)
            }
        }).then(onApiLoaded))
    }

    const promise = new Promise(resolve => {
        window.vueGoogleMapsInit = resolve
    }).then(onApiLoaded)

    return lazy(() => promise)
}

export default function install(Vue, options) {
    const resolvedOptions = {
        autobindAllEvents: false,
        ...options
    }
    const defaultResizeBus = createApp()
    const gmapApiPromiseLazy = makeGMapApiPromiseLazy(resolvedOptions)

    Vue.mixin({
        created() {
            this.$gmapDefaultResizeBus = defaultResizeBus
            this.$gmapOptions = resolvedOptions
            this.$gmapApiPromiseLazy = gmapApiPromiseLazy
        }
    })

    Vue.$gmapDefaultResizeBus = defaultResizeBus
    Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy
    Vue.component('GMapMap', GMapMap)
    Vue.component('GMapInfoWindow', GMapInfoWindow)
    Vue.component('GMapPolygon', GMapPolygon)
}
